import { Arrow, Color, LayerLine, Segment } from '@/types/models';
import { LayerObjectAdapter } from '@/utils/layer/LayerObjectAdapter';

export function getLayerLineAdapterId(id: number): string {
  return `line-${id}`;
}

export class LayerLineAdapter implements LayerLine, LayerObjectAdapter {
  public id: number;

  public z: number;

  public width: number;

  public layer: number;

  public color: Color;

  public segments: Segment[];

  public startArrow: Arrow;

  public endArrow: Arrow;

  public lineType: string;

  constructor(layerLine: LayerLine) {
    this.id = layerLine.id;
    this.z = layerLine.z;
    this.width = layerLine.width;
    this.layer = layerLine.layer;
    this.segments = layerLine.segments;
    this.startArrow = layerLine.startArrow;
    this.endArrow = layerLine.endArrow;
    this.lineType = layerLine.lineType;
    this.color = layerLine.color;
  }

  public getId(): string {
    return getLayerLineAdapterId(this.id);
  }

  public getOriginalId(): number {
    return this.id;
  }
}
